import { createElement } from "react";
import type { FC } from "react";
/*
  Nectary Icons need to be imported, the eslint plugins complains
  because it's not seeing them as used since it's dynamically created
*/
/* eslint-disable @nectary/imports */
import "@nectary/assets/icons-branded/barchart-down";
import "@nectary/assets/icons-branded/bell";
import "@nectary/assets/icons-branded/campaigns";
import "@nectary/assets/icons-branded/chatbot";
import "@nectary/assets/icons-branded/contact";
import "@nectary/assets/icons-branded/custom-message";
import "@nectary/assets/icons-branded/finance";
import "@nectary/assets/icons-branded/finance";
import "@nectary/assets/icons-branded/global-settings";
import "@nectary/assets/icons-branded/help";
import "@nectary/assets/icons-branded/home";
import "@nectary/assets/icons-branded/retail";
import "@nectary/assets/icons-branded/rocket";
import "@nectary/assets/icons-branded/settings";
import "@nectary/assets/icons-branded/user";
import "@nectary/assets/icons-branded/user";
import "@nectary/assets/icons-branded/users";
import "@nectary/assets/icons-branded/users";
import "@nectary/assets/icons-branded/verified-phone";
import "@nectary/assets/icons/arrow-back";
import "@nectary/assets/icons/check-circle";
import "@nectary/assets/icons/close";
import "@nectary/assets/icons/help";
import "@nectary/assets/icons/keyboard-arrow-down";
import "@nectary/assets/icons/keyboard-arrow-left";
import "@nectary/assets/icons/keyboard-arrow-right";
import "@nectary/assets/icons/keyboard-arrow-up";
import "@nectary/assets/icons/logout";
import "@nectary/assets/icons/menu";
import "@nectary/assets/icons/message";
import "@nectary/assets/icons/launch";
import "@nectary/assets/icons/reply";
import "@nectary/assets/icons/person";
import "@nectary/assets/icons/phonelink";
import "@nectary/assets/icons/star";
import "@nectary/assets/icons/dialer-sip";
import { z } from "zod";

// make sure to also import above the icons you add to the type below.
export const NectaryIconNameList = z.enum([
  "arrow-back",
  "branded-barchart-down",
  "branded-bell",
  "branded-campaigns",
  "branded-chatbot",
  "branded-contact",
  "branded-custom-message",
  "branded-finance",
  "branded-global-settings",
  "branded-help",
  "branded-home",
  "branded-retail",
  "branded-rocket",
  "branded-settings",
  "branded-user",
  "branded-users",
  "branded-verified-phone",
  "check-circle",
  "close",
  "help",
  "keyboard-arrow-down",
  "keyboard-arrow-left",
  "keyboard-arrow-right",
  "keyboard-arrow-up",
  "launch",
  "logout",
  "menu",
  "message",
  "person",
  "phonelink",
  "star",
  "reply",
  "dialer-sip",
]);

export type NectaryIconNames = z.infer<typeof NectaryIconNameList>;

type IconColor = "primary";

type IconProps = {
  name: NectaryIconNames;
  size?: number;
  slot?: string;
  /** Only available for the "branded" icons.. */
  inverted?: boolean;
  color?: IconColor;
};

const getIconColor = (colorName: IconColor) => {
  switch (colorName) {
    case "primary":
      return "--sinch-sys-color-primary-default";
    default:
      return "--sinch-sys-color-text-default";
  }
};

export const NectaryIcon: FC<IconProps> = ({ name, ...rest }) =>
  createElement(`sinch-icon-${name}`, {
    ...rest,
    style:
      "color" in rest
        ? {
            "--sinch-sys-color-text-default": `var(${getIconColor(
              rest.color
            )})`,
          }
        : undefined,
  });
